@let view = options();
@if (view.offersTrackerChoice) {
  <div
    class="trm__bug-tracker"
    role="group"
    data-testid="step-bug-tracker"
    [attr.aria-label]="'testRunner.bug.targetLabel' | translate"
  >
    @for (provider of view.providers; track provider) {
      <button
        type="button"
        class="trm__bug-tracker-option"
        [class.trm__bug-tracker-option--on]="provider === view.provider"
        [style.color]="provider === view.provider ? providerColor(provider) : null"
        [attr.aria-pressed]="provider === view.provider"
        [disabled]="locked()"
        (click)="selectProvider(provider)"
      >
        <span class="trm__bug-tracker-mark" aria-hidden="true" [style.background]="providerColor(provider)"></span>
        {{ providerLabel(provider) }}
      </button>
    }
  </div>
}
@if (view.offersBoardChoice) {
  <select
    #boardField
    class="trm__bug-board"
    data-testid="step-bug-board"
    [attr.aria-label]="'testRunner.bug.targetLabel' | translate"
    [disabled]="locked()"
    (change)="selectBoard(boardField.value)"
  >
    @for (board of view.boards; track board.id) {
      <option [value]="board.id" [selected]="board.id === view.target?.id">
        {{ providerLabel(board.providerType) }}: {{ boardLabel(board) }}
      </option>
    }
  </select>
}
